<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="criteresRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors"
                             :error="hasError"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="closeErrorMsg"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailClient.budget.filtre.lignesCommandeLibelle')">
            <b-input v-model="criteresRecherche.lignesCommandeLibelle ">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailClient.budget.filtre.lignesCommandeRegroupementLibelle')">
            <b-input v-model="criteresRecherche.lignesCommandeRegroupementLibelle ">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeLignesCommande.filtre.groupe')"
            dropdown="top"
            v-model="groupeSelected"
            :typologie="this.constantes.TYPOLOGIE_GROUPE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeLignesCommande.filtre.enseigne')"
            dropdown="top"
            v-model="enseigneSelected"
            :typologie="this.constantes.TYPOLOGIE_ENSEIGNE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailClient.budget.filtre.pointDeVente')">
            <qd-taginput
              v-model="pointDeVenteSelected"
              dropdown-position="top"
              icon="magnify"
              :data="filteredPointDeVente"
              autocomplete
              type="is-primary"
              :loading="isFetchingPointDeVente"
              field="nomCommercial"
              @typing="getFilteredPointDeVente">
              <template slot="empty">
                <div v-if="!isFetchingPointDeVente">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>{{$t('general.autocomplete.search')}}</div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('detailClient.budget.filtre.commercial')"
                        :blocked="userIsCommercialBlocked"
                        v-model="commercialSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailClient.budget.filtre.factureFaite')">
            <b-select v-model="criteresRecherche.estFacture" expanded>
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.apply')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import genererCriteresRechercheLigneARenouveler
  from '@/services/echeanceFacturation/genererCriteresRechercheEcheanceFacturation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { TYPOLOGIE_ENSEIGNE, TYPOLOGIE_GROUPE, TYPOLOGIE_POINT_DE_VENTE } from '@/configuration/tiers/tiersConf';
import { SET_CRITERE } from '@/store/modules/bodac/clients/EcheanceFacturation-mutation-type';
import queryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';

const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const EcheanceFacturation = createNamespacedHelpers('echeanceFacturation');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      criteresRecherche: null,
      commercialSelected: [],
      listeCommercial: [],
      commercialTags: null,
      hasError: false,
      errors: [],
      groupeSelected: [],
      enseigneSelected: [],
      pointDeVenteSelected: [],
      isFetchingPointDeVente: false,
      filteredPointDeVente: [],
      constantes: {
        TYPOLOGIE_ENSEIGNE,
        TYPOLOGIE_GROUPE,
      },
    };
  },
  components: {
    userTagInput,
    queryTiersTagInput,
    errorMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...EcheanceFacturation.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
    userIsCommercial() {
      return (this.user.profil === COMMERCIAL);
    },
    blocageFiltreCommercial() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
  },
  methods: {
    ...EcheanceFacturation.mapMutations({
      setCritereRecheche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getFilteredPointDeVente: debounce(async function getPointDeVentes(search) {
      this.filteredPointDeVente = [];
      if (!search) return;
      this.isFetchingPointDeVente = true;
      try {
        const pointDeVentes = (await getAllTiers(
          {
            query: {
              auto: search,
              typologie: [TYPOLOGIE_POINT_DE_VENTE],
              societeId: this.societeActiveId,
            },
          },
        )).data.result.items;
        this.filteredPointDeVente = pointDeVentes.filter((pdv) => {
          return !this.pointDeVenteSelected.map(
            pdvSelected => pdvSelected.id,
          ).includes(pdv.id);
        });
        this.isFetchingPointDeVente = false;
      } catch (e) {
        this.isFetchingPointDeVente = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    viderCritere() {
      this.criteresRecherche = cloneDeep(genererCriteresRechercheLigneARenouveler());
      this.commercialSelected = [];
      this.groupeSelected = [];
      this.enseigneSelected = [];
      this.pointDeVenteSelected = [];
      if (this.filtrerParUtilisateur && this.userIsCommercial) {
        this.criteresRecherche.commercialId.push(this.user.id);
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.user.id === c.id;
        });
      }
    },
    appliquerCritere() {
      this.criteresRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.criteresRecherche.groupeIds = this.groupeSelected;
      this.criteresRecherche.enseigneIds = this.enseigneSelected;
      this.criteresRecherche.pointDeVenteIds = this.pointDeVenteSelected;
      this.setCritereRecheche(this.criteresRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.criteresRecherche = cloneDeep(this.criteresRechercheFromStore);
        await this.loadParametreUtilisateur();
        await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key]);
        this.listeCommercial = initialUsers(this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif), [DIRECTEUR_COMMERCIAL, COMMERCIAL]);

        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.criteresRecherche.commercialId.includes(c.id);
        });
        this.enseigneSelected = this.criteresRecherche.enseigneIds;
        this.groupeSelected = this.criteresRecherche.groupeIds;
        this.pointDeVenteSelected = this.criteresRecherche.pointDeVenteIds;
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key]);

        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
